import { combineReducers } from 'redux';
import _omit from 'lodash/omit';

import errors from './errors';

import {
  ACTION_SET_XCARD,

  ACTION_LOAD_XCARD_INIT__SUCCESS,
  ACTION_LOAD_XCARD_INIT__FAIL,
} from '../actionTypes';


const formSettings = (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_XCARD_INIT__SUCCESS:
      return _omit(action.payload.formSettings, ['card']);

    case ACTION_LOAD_XCARD_INIT__FAIL:
      return null;

    default:
      return state;
  }
};

const card = (state = null, action) => {
  switch (action.type) {
    case ACTION_SET_XCARD:
      return action.payload.card;

    case ACTION_LOAD_XCARD_INIT__SUCCESS:
      return action.payload.formSettings.card;

    case ACTION_LOAD_XCARD_INIT__FAIL:
      return null;

    default:
      return state;
  }
};

export default combineReducers({
  formSettings,
  card,
  errors,
});
